<template>
  <div>
    <b-modal
      v-if="detailsFile"
      :id="`modal-action-${action}`"
      :ref="`modal-action-${action}`"
      :title="`${title} documento`"
      :ok-title="title"
      cancel-title="Cancelar"
      no-close-on-backdrop
      @ok="commitAction"
      @cancel="cancelProcess"
      size="lg"
      centered
    >
      <div class="-mt-2">
        <form
          data-vv-scope="sign-document"
          class="mt-4"
        >
          <div class="row">
            <div class="col-6 mt-3">
              <label>Fecha</label>
              <b-form-datepicker
                :min="min"
                id="example-datepicker"
                v-model="manageDate"
                class="w-100"
                label-help="Puede usar las flechas del teclado y espacio"
              />
            </div>
            <div class="col-6 mt-3">
              <vs-input
                type="number"
                class="w-100"
                label="Código OTP"
                maxlength="6"
                name="otp"
                v-model="otpCode"
                v-validate="'required'"
                :danger="errors.has('sign-document.otp')"
                :danger-text="errors.first('sign-document.otp')"
              />
            </div>
          </div>
        </form>
      </div>
    </b-modal>
    <b-modal
      title-class="font-weight-bold text-success"
      centered
      size="sm"
      no-close-on-backdrop
      title="Genial!"
      ref="numerateModal"
      id="numerateModal"
      hide-header-close
    >
      <h5>Se ha tramitado el documento exitosamente</h5>
      <template #modal-footer="{ ok }">
        <div class="w-100">
          <b-button
            variant="success"
            class="float-right"
            @click="ok($router.back())"
          >
            Ok
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import {
  VBToggle,
  BModal,
  VBModal
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { uuid } from 'vue-uuid';

export default {
  components: {
    BModal
  },
  data() {
    return {
      min: this.$moment().subtract(5, 'days').format('YYYY-MM-DD'),
      error: {
        message: ''
      },
      otpCode: '',
      signType: '',
      numeration: '',
      manageDate: this.$moment().format('YYYY-MM-DD'),
      confirmed: false,
      noAction: false,
      folio: '',
      actionType: ''
    };
  },
  computed: {
    ...mapGetters('Management', [
      'allDocuments'
    ]),
    ...mapGetters('Empresas', [
      'userSignConfiguration'
    ]),
    ...mapGetters('Dnts', [
      'detailsFile'
    ]),
    ...mapGetters('Approvals', [
      'loadingNumeration',
      'fileOnFlow'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ])
  },
  methods: {
    ...mapActions('Approvals', [
      'processFileFlow',
      'manageFileFlow',
      'setProcessDocument'
    ]),
    cancelProcess() {},
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async signDocument() {
      const isValid = await this.validateForm('sign-document');
      if (!isValid) {
        return;
      }
      const sign = this.getSign();

      if (!(sign.y >= 0 && sign.x >= 0)) {
        this.$bvToast.toast(
          'No has colocado la ubicación de la estampa',
          {
            title: '¡Oops!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }

      const body = {
        folio: this.numeration,
        pasoId: this.stepId.id,
        ejecucionId: this.$route.params.flowId,
        aprobacionId: this.$route.params.fileId,
        documentoId: uuid.v1(),
        codigoAutenticador: this.otpCode,
        password: 'na',
        tipoFirma: 'firmaSimple',
        idDigitalFirma: this.currentUser.iut,
        OTP: this.otpCode,
        paginaFirma: sign.page,
        // eslint-disable-next-line radix
        coordenadaY: parseInt(sign.y),
        coordenadaX: sign.x,
        cordenadasAlto: sign.height,
        cordenadasAncho: sign.width
      };

      const meta = {
        fecha: this.manageDate,
        accion: 'fechar'
      };

      const response = await this.manageFileFlow({ body, meta });
      console.log(response);
      this.$refs.numerateModal.show();
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.signDocument();
    }
  },
  props: {
    action: { type: String, required: true },
    title: { type: String, required: true },
    process: { type: Boolean, required: false },
    stepId: { type: Object, required: false },
    getSign: Function,
    numPages: Number
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>
<style scoped>
.wrap-numeration {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.warning-confirmation {
  background-color: #ff9800;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}
</style>
